import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=879c48c2&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879c48c2",
  null
  
)

export default component.exports